export const addDiametersToVehicle = (vehicle) => {
  let diameters
  if (vehicle && vehicle.rimSizes)
    diameters = [...new Set(vehicle.rimSizes.map(size => parseInt(size.diameter, 10)))]
  else
    diameters = []
  return Object.assign({}, vehicle, { diameters })
}